import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'

import { MIN_PASS_LENGTH } from 'shared/utils/forms'

import { changePassword } from 'features/profile/actions'
import { selectChangePasswordComm } from 'features/profile/selectors'

const validationSchema = yup.object().shape({
  oldPassword: yup.string().required('required'),
  newPassword: yup.string().min(MIN_PASS_LENGTH, 'minPassLength').required('required'),
  repeatNewPassword: yup
    .string()
    .required('required')
    .oneOf([yup.ref('newPassword'), ''], 'passwordsDoNotMatch'),
})

type ChangePasswordForm = {
  oldPassword: string
  newPassword: string
  repeatNewPassword: string
}

type UseChangePasswordFormProps = {
  initialValues?: ChangePasswordForm
  onSuccess?: () => void
}

export const useChangePassword = (props?: UseChangePasswordFormProps) => {
  const dispatch = useDispatch()
  const { error, isLoading, isSuccess } = useSelector(selectChangePasswordComm, shallowEqual)

  const initialValues = props?.initialValues || {
    oldPassword: '',
    newPassword: '',
    repeatNewPassword: '',
  }

  const formik = useFormik<ChangePasswordForm>({
    initialValues,
    validationSchema,
    onSubmit: values => {
      dispatch(
        changePassword({
          data: values,
          callback: props?.onSuccess,
        }),
      )
    },
  })

  return {
    formik,
    error,
    isLoading,
    isSuccess,
  }
}
